// removed by extract-text-webpack-plugin
module.exports = {"shiftItem":"_3Ugi7R3Mn416H1LA5dhrHS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftsOverview/ShiftTableItem.css
// module id = 204
// module chunks = 0